import { useNavigate } from '@tanstack/react-router';
import { ClipboardList } from 'lucide-react';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import { BookingTourBasicDataDto } from '@/features/public/booking/types/BookingTourBasicDataDto.ts';
import { bookingRoute } from '@/features/public/booking/routes/bookingRoutes.ts';

type WaitlistCtaProps = {
  tourBasicInfo: BookingTourBasicDataDto;
  description?: string;
};

/**
 * Zaproszenie na listę rezerwową. Pokazujemy je wyłącznie w oknie listy — poza
 * nim backend odbiłby zapis, a klient wypełniłby formularz na darmo.
 *
 * W praktyce jedyny ekran, na którym CTA bywa żywy, to „zapisy zamknięte":
 * okno listy sięga granicy z dat wyjazdu, więc trwa jeszcze po dacie zamknięcia
 * zapisów ustawionej przez organizatora. Przed otwarciem zapisów lista nie
 * przyjmuje zgłoszeń, a pełny wyjazd z otwartą listą idzie przekierowaniem
 * prosto na `/waitlist`.
 */
const WaitlistCta = ({ tourBasicInfo, description }: WaitlistCtaProps) => {
  const { orgSlug, tourSlug } = bookingRoute.useParams();
  const navigate = useNavigate();

  if (!tourBasicInfo.waitlistAvailable) return null;

  return (
    <div className="space-y-2 rounded-md border border-neutral-200 bg-basic-white p-4">
      <p className="text-sm text-neutral-600">
        {description ??
          'Zapisz się na listę rezerwową — damy znać, gdy zwolni się miejsce.'}
      </p>
      <ActionButton
        tone="accent"
        size="sm"
        onClick={() =>
          navigate({
            to: '/waitlist/$orgSlug/$tourSlug',
            params: { orgSlug, tourSlug },
          })
        }
      >
        <ClipboardList />
        Zapisz się na listę rezerwową
      </ActionButton>
    </div>
  );
};

export default WaitlistCta;
